import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  STATUS_CONTAINER: `${cleanedFilename(__filename)}-status-container`,
  REPLY_BUTTON: `${cleanedFilename(__filename)}-reply-button`,
};
